import { RouterThunk } from '@gasbuddy/react';
import { Devtools } from './devtools';

import {
  Home,
  identity,
  auth,
  payments,
  loyalty,
  system,
  poi,
  Unknown,
  Unauthorized,
  Reports,
} from './pages';

const routes = {
  routes: [{
    component: Home,
    exact: true,
  }],
  identity,
  auth,
  payments,
  loyalty,
  system,
  poi,
  final: {
    routes: [
      { component: Reports, path: '//reports', exact: true },
      { component: Reports, path: '//reports/:report', exact: true },
      { component: Unauthorized, path: '//401', exact: true },
      { component: Unknown, path: '//' },
    ],
  },
};

if (process.env.NODE_ENV !== 'production') {
  routes.routes.push({
    component: Devtools,
    path: '/devtools',
    exact: true,
  });
}

export const Router = RouterThunk(routes);
